<template>
  <a role="button" class="whitespace-nowrap text-sm" @click="showTransferOwnershipDialog"
    >Transfer ownership</a
  >
</template>

<script>
export default {
  props: {
    membership: {
      type: Object,
      required: true,
    },
  },
  methods: {
    showTransferOwnershipDialog() {
      this.$modal.show({
        component: () => import('./TransferOwnershipDialog.vue'),
        props: {
          membership: this.membership,
        },
        on: {
          success: () => {
            this.$emit('transfered');
          },
        },
        hideEvent: 'close',
      });
    },
  },
};
</script>
